/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// ファイルサイズ変換
	const bytesToSize = (bytes) => {
		var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
		if (bytes === 0) {
			return 'n/a';
		}
		var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
		if (i === 0) {
			return bytes + ' ' + sizes[i];
		}
		return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
	}
	if(document.querySelectorAll('.js-fileSize').length) {
		document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
			pdfElement.innerText = bytesToSize(pdfElement.innerText);
		});
	}
	if(document.querySelectorAll('.rt_cf_n_attachment_file_size').length) {
		document.querySelectorAll('.rt_cf_n_attachment_file_size').forEach(function (pdfElement) {
			pdfElement.innerText = bytesToSize(pdfElement.innerText);
		});
	}
	if(document.querySelectorAll('.rt_cf_n_url_file_size').length) {
		document.querySelectorAll('.rt_cf_n_url_file_size').forEach(function (pdfElement) {
			pdfElement.innerText = bytesToSize(pdfElement.innerText);
		});
	}
	if(document.querySelectorAll('.js-product-e3-current').length) {
		document.querySelectorAll('.js-product-e3-current').forEach(ele => {
			console.log(ele.pathname);
			if(ele.pathname == location.pathname) {
				ele.classList.add(a);
			}
		});
	}
	// 製品検索
	if(document.querySelectorAll('.js-product-search-form').length) {
		let $form = document.querySelector('.js-product-search-form');
		let $tab = document.querySelectorAll('.js-product-search-tab');
		let $content = document.querySelectorAll('.js-product-search-tabContent');
		let $btn = document.querySelector('.js-product-search-button');
		let $kbtn = document.querySelector('.js-product-search-keyword-button');
		let $clearbtn = document.querySelector('.js-product-search-clear');
		let $kinput = document.querySelector('.js-product-search-keyword');
		const formSubmit = () => {
			if($kinput.value) {
				let karray = $kinput.value.replaceAll(/[\"]/g,"").normalize("NFKC").split(/\s/);
				karray.forEach((eleK,idxK) => {
					console.log(eleK,idxK);
					if(idxK == 0) {
						keywordInputs = '<input name="p_keyword1" type="hidden" value="'+eleK+'" />';
						$form.insertAdjacentHTML('afterbegin', keywordInputs);
					} else if(idxK == 1) {
						keywordInputs = '<input name="p_keyword2" type="hidden" value="'+eleK+'" />';
						$form.insertAdjacentHTML('afterbegin', keywordInputs);
					} else if(idxK == 2) {
						keywordInputs = '<input name="p_keyword3" type="hidden" value="'+eleK+'" />';
						$form.insertAdjacentHTML('afterbegin', keywordInputs);
					} else if(idxK == 3) {
						keywordInputs = '<input name="p_keyword4" type="hidden" value="'+eleK+'" />';
						$form.insertAdjacentHTML('afterbegin', keywordInputs);
					} else if(idxK == 4) {
						keywordInputs = '<input name="p_keyword5" type="hidden" value="'+eleK+'" />';
						$form.insertAdjacentHTML('afterbegin', keywordInputs);
					}
				});
			}
			$form.submit();
			return false;
		};
		// タブ切り替え
		$tab.forEach(ele => {
			ele.addEventListener('click', () => {
				$tab.forEach(ele2 => { ele2.classList.remove('current'); })
				ele.classList.add('current');
				let _target = ele.getAttribute('data-target');
				$content.forEach(ele3 => {
					ele3.classList.add('hide');
					if (ele3.getAttribute('data-target').match(_target)) {
						ele3.classList.remove('hide');
					}
				});
				// フォームクリア
				// $form.reset();
			});
		});
		document.querySelector('.div_searchby_business').querySelectorAll('input[type="checkbox"]').forEach((ele) => {
			ele.addEventListener('change', (event) => {
				document.querySelectorAll('.js-product-search-tabContent.hide').forEach((hideele) => {
					hideele.querySelectorAll('input[type="checkbox"]').forEach((hideeleinput) => {
						hideeleinput.checked = false;
					});
				});
			});
		});
		
		// 初期表示パラメータを見てvalue入れ込み
		let urlParam = location.search.substring(1);
		let paramArray = [];
		if(urlParam) {
			let param = urlParam.split('&');
			for(let i = 0; i < param.length; i++) {
				let paramItem = param[i].split('=');
				paramArray[paramItem[0]] = paramItem[1];
			}
		}
		let kewordValue = '';
		if(paramArray.p_keyword1) {
			kewordValue += (paramArray.p_keyword1 + ' ');
		}
		if(paramArray.p_keyword2) {
			kewordValue += (paramArray.p_keyword2 + ' ');
		}
		if(paramArray.p_keyword3) {
			kewordValue += (paramArray.p_keyword3 + ' ');
		}
		if(paramArray.p_keyword4) {
			kewordValue += (paramArray.p_keyword4 + ' ');
		}
		if(paramArray.p_keyword5) {
			kewordValue += (paramArray.p_keyword5 + ' ');
		}
		$kinput.value = decodeURI(kewordValue);
		// submit
		$kinput.addEventListener("keydown", (e) => {
			if(e.keyCode === 13){
				formSubmit();
			}
		});
		$kbtn.addEventListener('click', () => {
			formSubmit();
		});
		$btn.addEventListener('click', () => {
			formSubmit();
		});
		$clearbtn.addEventListener('click', () => {
			$form.reset();
			document.querySelector('.js-product-search-form').querySelectorAll('input[type="checkbox"]').forEach((ele) => {
				ele.checked = false;
			});
		});
		// checkbox、ユニークid・label付与
		document.querySelector('.js-product-search-form').querySelectorAll('input[type="checkbox"]').forEach((eleinput,eleindex) => {
			eleinput.id = eleindex;
			eleinput.nextElementSibling.htmlFor = eleindex;
		});
		$form.classList.remove('di_none');
	};
	// 製品検索関連ワード表示
	if(document.querySelectorAll('.js-products-search-word').length) {
		let itemArray = [];
		document.querySelectorAll('input[type="checkbox"]').forEach(ele => {
			if(ele.checked) {
				let etext = ele.nextElementSibling.textContent;
				itemArray.push(etext);
			}
		});
		// console.log(itemArray);
		// console.log(Object.keys(itemArray).length,document.querySelectorAll(itemArray).length);
		if(Object.keys(itemArray).length) {
			document.querySelector('.js-products-search-word').classList.remove('di_none');
			itemArray.forEach(arrele => {
				let HTML = '<li><a style="pointer-events:none;">'+arrele+'</a></li>'
				document.querySelector('.js-products-search-word').insertAdjacentHTML('beforeend', HTML);
			});
		}
	}
	// ピックアップ表示
	const getJSONfiles = (_id) => {
		return `/ajax/products/detail/${_id}.json`;
	};
	if(document.querySelectorAll('.js-products-top-pickup').length) {
		document.querySelectorAll('.js-products-top-pickup').forEach(ele => {
			fetch(getJSONfiles(ele.querySelector('.rt_cf_p_id_g').textContent)).then(function (data) {
				return data.json();
			}).then(function (data) {
				console.log(data.rt_bn_products_detail[0],'data',ele);
				let title = data.rt_bn_products_detail[0].cf_p_classification.cf_pcl_classification_name_ja; // 分類名
				let status1 = data.rt_bn_products_detail[0].cf_p_classification.cf_pcl_status; // 分類公開可否(0 or 1)
				let status2 = data.rt_bn_products_detail[0].cf_p_status; // 製品公開可否(0 or 1)
				ele.querySelector('.js-products-top-pickup-text').textContent = title;
				data.rt_bn_products_detail[0].cf_p_tags.forEach(tagslem => {
					if(tagslem._key == 'environmental_impact_reduction_products') {
						ele.querySelector('.tag_greenWrap').classList.remove('di_none');
					}
					if(tagslem._key == 'social_contribution_products') {
						ele.querySelector('.tag_blueWrap').classList.remove('di_none');
					}
				});
				if((status1 == 0) || (status2 == 0)) {
					ele.remove();
				}
			});
		});
	}
	// からタグ消込
	if(document.querySelectorAll('.ul_tags .cf_p_tags').length) {
		document.querySelectorAll('.ul_tags .cf_p_tags').forEach(ele => {
			if(!ele.textContent) {
				ele.classList.add('di_none');
			}
		});
	}
	// easeScroll-products-search
	window.addEventListener('load', () => {
		function getParam(name, url) {
			if (!url) url = window.location.href;
			name = name.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		}
		if (location.pathname.replace('index.html', '') == '/products/search/') {
			if(getParam('p_product_id')) {
				// document.documentElement.style.display = 'none';
				// document.body.style.display = 'none';
				setTimeout(() => {
					// document.documentElement.style.display = 'block';
					// document.body.style.display = 'block';
					let pos = document.getElementById('js-easeScroll-products-search').getBoundingClientRect().top;
					if(window.innerWidth < 1025) {
						pos = pos - 70;
					} else {
						pos = pos - 100;
					}
					window.scrollTo({ top: pos, behavior: 'smooth' });
				}, 100);
			}
		}
	});

})(window.FUNCTIONS);